// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hv","advertCardHeader__actions":"c-a_hw","advertCardHeader__bottomLabel":"c-a_hx"};